import React, {useState, useContext} from 'react'

import 'react-quill/dist/quill.snow.css';

import StateContext from '../../StateContext'
import { firestore } from '../../firebase';
import { Link, Redirect } from 'react-router-dom';

function CreatePost(props) {

    const appState = useContext(StateContext)

    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState()

    // ACF
    const [description, setDescription] = useState("")
    const [servings, setServings] = useState(4)
    const [prepTime, setPrepTime] = useState(20)
    const [dietDescription, setDietDescription] = useState()

    const [featuredImageRecipe, setFeaturedImageRecipe] = useState("https://camillahardilla.com/wp-content/uploads/2020/07/bakst.jpeg")

    const [created, setCreated] = useState(false)
    const [recipeId, setRecipeId] = useState("")

    async function handleSubmit(e) {
        e.preventDefault()
        setIsLoading(true)

        const recipeRef = firestore.collection("recipes");

        const datePost = new Date();

        const recipeData = {
            author_id: appState.userId,
            author_name: "Ole Petter",
            date: datePost,
            title,
            diet: dietDescription,
            portions: +servings,
            preparation_time: +prepTime,
            imageUrl: featuredImageRecipe,
            categories: []
        }

        console.log(recipeData)
        
        try {
            const data = await recipeRef.add(recipeData);
            if (data) {
                setCreated(true)
            }
            console.log(data.id)
            setRecipeId(data.id)
        } catch (error) {
            console.log("Noe gikk galt: ", error)
        }

        setIsLoading(false)
        
    }

    if (appState && !appState.loggedIn) return <p>Logg inn</p>


    return (
        <div>
            
            <div className="container my-4">

                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="post-title" className="text-muted mb-1">
                            <small>Recipe title</small>
                        </label>
                        <input required onChange={e => setTitle(e.target.value)} autoFocus name="title" id="post-title" className="form-control form-control-lg form-control-title" type="text" placeholder="Recipe title" autoComplete="off" />
                    </div>

                    <label>Add recipe picture</label>
                    <input type="text" onChange={e => setFeaturedImageRecipe(e.target.value)} className="form-control mb-2" placeholder="Recipe picture" />

                    <br/>
                
                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Short Description</small>
                    </label>
                    <textarea onChange={(e) => setDescription(e.target.value)} name="fields[beskrivelse_oppskrift]" placeholder="Recipe description" className="form-control mb-2" />

                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Total servings</small>
                    </label>
                    <input onChange={(e) => setServings(e.target.value)} type="number" name="fields[antall_serveringer]" placeholder="Portions" className="form-control mb-2" />

                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Prep Time</small>
                    </label>
                    <input onChange={(e) => setPrepTime(e.target.value)} type="number" name="fields[forberedelse_oppskrift]" placeholder="Total time" className="form-control mb-2" />
                    
                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Diets</small>
                    </label>
                    <input onChange={(e) => setDietDescription(e.target.value)} name="fields[diet]" placeholder="Diet(s)" className="form-control mb-2" />

                    <br/>         

                    <hr/>
                    
                    {created && recipeId && (
                        <div className="alert alert-success">Recipe added! View new recipe: <Link to={`/innlegg/single/${recipeId}`}>View recipe</Link></div>
                    )}
                    <button className="btn btn-primary" disabled={isLoading}>{isLoading ? "Saving" : "Save post"}</button>
                </form>
            </div>
        </div>
    )
}
export default CreatePost